import React from 'react';
import { Box, Tooltip, CardContent, Button, Theme } from '@material-ui/core';
import { Trash as DeleteIcon } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) => ({
    deleteButton: {
        backgroundColor: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
    },
    button: {
        textTransform: 'capitalize',
    },
}));

export interface ServiceClientsBulkActionsHeaderProps {
    /** Called when the delete button is clicked. No-op by default until delete flow is implemented. */
    onDeleteClick?: () => void;
}

/**
 * Bulk actions header for the service clients list.
 * Currently only shows a Delete button (no functionality yet).
 */
export const ServiceClientsBulkActionsHeader = ({
    onDeleteClick,
}: ServiceClientsBulkActionsHeaderProps) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const labelDelete = t('Buttons.Delete');

    const handleDelete = () => {
        onDeleteClick?.();
    };

    return (
        <CardContent
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                height: 80,
            }}
        >
            <Box
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 20,
                }}
            >
                <Tooltip title={labelDelete}>
                    <Button
                        onClick={handleDelete}
                        data-testid="service-clients-bulk-delete-button"
                        variant="contained"
                        color="primary"
                        startIcon={<DeleteIcon />}
                        className={classes.deleteButton + ' ' + classes.button}
                    >
                        {labelDelete}
                    </Button>
                </Tooltip>
            </Box>
        </CardContent>
    );
};
